<div class="content">
  <div>
    <mat-icon>error</mat-icon>
  </div>
  <div>
    <span>Något gick tyvärr fel, försök igen senare</span>
  </div>
</div>
